export function useGraphicOverlayWidth(size) {
    return computed(() => {
        switch (unref(size)) {
            case 'lg':
                return '21.25rem'
            case 'md':
                return '10.625rem'
            case 'sm':
                return '7.5rem'
            default:
                return ''
        }
    })
}

export function useGraphicOverlayPaddingClasses(padding) {
    return computed(() => {
        switch (unref(padding)) {
            case 'sm':
                return 'p-4'
            case 'md':
                return 'p-6'
            case 'lg':
                return 'p-8'
            case 'none':
            default:
                return ''
        }
    })
}

export function getGraphicOverlayGridPosition(position) {
    switch (position) {
        case 'offset-top-left':
            return 'left-0 top-0 -translate-y-1/2'
        case 'offset-top':
            return 'left-1/2 top-0 -translate-y-1/2 -translate-x-1/2'
        case 'offset-top-right':
            return 'right-0 top-0 -translate-y-1/2'
        case 'top-left':
            return 'left-0 top-0'
        case 'top':
            return 'left-1/2 top-0 -translate-x-1/2'
        case 'top-right':
            return 'right-0 top-0'
        case 'left':
            return 'left-0 top-1/2 -translate-y-1/2'
        case 'right':
            return 'right-0 top-1/2 -translate-y-1/2'
        case 'bottom-left':
            return 'left-0 bottom-0'
        case 'bottom':
            return 'left-1/2 bottom-0 -translate-x-1/2'
        case 'bottom-right':
            return 'right-0 bottom-0'
        case 'offset-bottom-left':
            return 'left-0 bottom-0 translate-y-1/2'
        case 'offset-bottom':
            return 'left-1/2 bottom-0 translate-y-1/2 -translate-x-1/2'
        case 'offset-bottom-right':
            return 'right-0 bottom-0 translate-y-1/2'
        case 'center':
        default:
            return 'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'
    }
}

